import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useAuth } from '../../../contexts/AuthContext';
import { useUserOrganizations, setSelectedOrganization } from '../hooks/useOrganization';

/**
 * Organization switcher for D&A pages.
 *
 * Renders a compact dropdown when the user can see more than one organization
 * (e.g. their Magnum, Inc. beta copy plus a company they created themselves).
 * Selection persists per user and re-orders useUserOrganizations so every
 * D&A page follows along. Renders nothing for single-org users.
 */
export default function OrgSwitcher({ sx = {} }) {
  const { user } = useAuth();
  const { organizations } = useUserOrganizations(user?.uid);

  if (!user || organizations.length < 2) return null;

  const activeId = organizations[0]?.id || '';

  return (
    <FormControl size="small" sx={{ minWidth: { xs: 0, sm: 200 }, width: { xs: '100%', sm: 'auto' }, maxWidth: '100%', ...sx }}>
      <InputLabel id="org-switcher-label">Organization</InputLabel>
      <Select
        labelId="org-switcher-label"
        label="Organization"
        value={activeId}
        onChange={(e) => setSelectedOrganization(user.uid, e.target.value)}
      >
        {[...organizations]
          .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
          .map((org) => (
            <MenuItem key={org.id} value={org.id}>
              {org.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
